<h5 class="font-normal flex items-center justify-center md:justify-end">
  Your cart will expire in...
  <span class="ml-1 font-bold">{{ getTimer }}</span>
  <span class="ml-2"><img src="/assets/img/clock-icon.svg" alt="" /></span>
</h5>
